import React, { useState, useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import "./WelcomeSuperStarPrint.css";
import axios from "axios";
import "../WelcomeSuperstar/WelcomeSueprstar.css";
import backgroundBanner from "../../../../../assets/images/backGroundBanner.png";
import helloSuperStarLogo from "../../../../../assets/images/helloSuperStar.png";
import footerPhoto from "../../../../../assets/images/24783.jpg";
import { Markup } from "interweave";
import QRCode from "react-qr-code";
import Pdf from "react-to-pdf";
import ReactToPrint from "react-to-print";
import LoaderPost from "../../../../Reuseable/LoaderPost";

const WelcomeSuperStarPrint = () => {
  const componentRef = useRef();

  const { star_id } = useParams();

  const [loading, setLoading] = useState(true);
  const [star, setStar] = useState([]);

  const ref1 = React.createRef();

  useEffect(() => {
    axios.get(`/api/admin/agreement_paper/${star_id}`).then((res) => {
      if (res.data.status === 200) {
        setStar(res.data.star);
        setLoading(false);
      }
    });
  }, []);

  if (loading) {
    return <LoaderPost />;
  } else {
  }

  return (
    <>
      <div className="container">
        <div className="d-flex justify-content-end">
          <div>
            <ReactToPrint
              trigger={() => (
                <i class="fa-solid fa-print Print text-light p-2"></i>
              )}
              content={() => componentRef.current}
            />

            {/* <Pdf targetRef={ref1} filename="star-qr-code.pdf">
              {({ toPdf }) => (
                <i
                  class="fa-solid fa-file-arrow-down  DownLoad text-light p-2 mx-2"
                  onClick={toPdf}
                ></i>
              )}
            </Pdf> */}
          </div>
        </div>
        <div className="row justify-content-center d-flex">
          <div className="col-md-9 justify-content-center d-flex">
            <div style={{ width: "720px" }}>
              <div style={{ margin: "0", padding: "0" }} ref={ref1}>
                <div ref={componentRef} bgColor="#000">
                  <table bgColor="#fff">
                    <tr
                      style={{
                        backgroundImage:
                          "url(" +
                          "https://www.hellosuperstars.com/static/media/headpdf.png" +
                          ")",
                        backgroundPosition: "center",
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                      }}
                    >
                      <td>
                        <center>
                          <img
                            src={helloSuperStarLogo}
                            alt=""
                            style={{ margin: "40px 20px 20px 20px" }}
                            width={120}
                          />
                        </center>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <h5 className="Dear-star">Dear,</h5>
                        <h1 className="Star-Name">
                          {star?.super_star?.first_name}{" "}
                          {star?.super_star?.last_name}
                        </h1>
                        <h4 className="welcome-Star">
                          Welcome to Hello Super Stars
                        </h4>{" "}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div
                          style={{ padding: "0px 40px", textAlign: "justify" }}
                        >
                          <Markup content={star?.terms_and_condition} />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <center>
                          <QRCode
                            value={star?.qr_code}
                            size={100}
                            style={{ margin: "40px 20px 0px 20px" }}
                          />
                          <div>{star?.qr_code}</div>
                        </center>
                      </td>
                    </tr>
                  </table>
                  <img
                    src={footerPhoto}
                    alt=""
                    style={{
                      maxHeight: "100px",
                      width: "100%",
                      position: "fixed:",
                      bottom: "0",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WelcomeSuperStarPrint;
